
import { defineComponent, SetupContext } from "vue";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "PantryCameraRadioItem",
  components: {
  },
  props: {
    id: {
      type: Number,
      default: -1
    },
    selectId: {
      type: Number,
      default: 0
    },
    valueText: {
      type: String,
      detault: "" 
    }
  },
  setup(props, context: SetupContext) {
    const getRadioImage = () => {
      return (props.id == props.selectId) ? require("@/assets/images/icn-check-on-circle.png") : require("@/assets/images/radio_off.png");
    };
    const onClickRadio = () => {
      context.emit("select-check", props.id);
    };
    return {
      onClickRadio,
      getRadioImage
    }
  }
});
